import { initialValues } from "../../pages/digi/NewMasterSheet/LeaseProcess/Flow/StepperComponents/lease/components/config/initialValues";
import { SET_FORM_DATA, RESET_FORM } from "./actionTypes";

const leaseFormReducer = (state = initialValues, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return initialValues;

    default:
      return state;
  }
};

export default leaseFormReducer;